angular.module('rightPaneModule')
  .controller('DistrictPerformanceController', ['$scope', 'schoolApi', '$state', 'tableColumns', 'tableSort', 'timeframe', 'reportErrors', function($scope, $schoolApi, $state, $tableColumns, $tableSort, $timeframe, $reportErrors) {

      var updateMode = function() {
          $scope.listTableColumns = $tableColumns.getColumns('schoolPerformance_fractions');
      };

      updateMode();

      $scope.years = {list: null, selected: {}};

      $scope.timeframes = {
          list: [
              // remove 7 and 30 days for now
              //{ id: '7d', name: 'Last 7 Days', active: false },
              //{ id: '30d', name: 'Last 30 Days', active: true }
          ],
          selected: {}
      };

    var initializeClusterData = function() {
        // if no timeframe, or timeframe is not a year, default to current year
        if(!$state.params.timeframe || !$timeframe.isYearParam($state.params.timeframe)) {
            $timeframe.updateStateParams($scope.timeframes.selected.id, $scope.timeframes.selected.by)
              .then(function() {
                  updateClusterData();
              });
        } else {
            updateClusterData();
        }
    };

      var updateClusterData = function () {
          updateMode();

          $scope.busy = true;
          $scope.reportError = null;
          $schoolApi.getSchoolsReporting().then(function(data) {
              $scope.listTableData = $tableSort.sortColumn($scope.listTableColumns, angular.copy(data));
              $scope.frequencyGraphData = angular.copy(data);
              $scope.busy = false;
          }, function(error) {
              $scope.busy = false;
              $scope.reportError = $reportErrors.getErrorMessage(error);
          });
      };

      var sortTableData = function () {
          // No need to make an api call since it's the same data
          $scope.listTableData = $tableSort.sortColumn($scope.listTableColumns, $scope.listTableData);
      };

    var initializeData = function(e, item) {
        // temp set current year as selected
        var currentYearParam = $timeframe.calculateCurrentReportingYearParam();
        $scope.timeframes.selected = { id: currentYearParam, name: 'Current School Year', by: 'month', active: true };

        $scope.item = item;
        initializeClusterData();
    };

      $scope.$on('itemReady', initializeData);

      $scope.$on('updateSortableTable', sortTableData);

      $scope.$on('listTableRowClicked', function (e, item) {
          $scope.$emit('route', item);
      });

      $scope.$on('timeframeSelected', updateClusterData);

      $scope.$on('updateYears', function (e, years) {
          $scope.years.list = angular.copy(years);
      });

  }]);
